/* eslint-disable */
import { bus } from '@/main';
import { mapGetters } from 'vuex';
var $ = window.jQuery = require('jquery');

export default {
  name: 'landing-page',
  components: {
  },
  props: [],
  data() {
    return {
      preloader: true,
      loginBtnStatus:false
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  mounted() {
    bus.$emit('authBtnShowBus', false)
    if(this.$store.getters.isAuthenticated){
      this.loginBtnStatus = true
    }
    this.ShowLoader()
  },
  beforeMount() {
    $('body').addClass('login')
  },
  methods: {
    ShowLoader() {
      setTimeout(() => {
        this.preloader = false
      }, 500)
    },
  },
  beforeCreate: function() {
    $('body').addClass('login')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('login')
    next();
  }
}